module.exports = __webpack_public_path__ + "static/media/locknox-2.dd711f54.jpg";